import React from 'react';
import { Col, Form, Input, Row, Select, Typography } from 'antd';
import UploadButton from '../../../../../components/common/UploadButton';

const { Title } = Typography;

const Step4InteriorFinalInspectionForm = ({ fileList, setFileList }) => {

  // Dropdown options for different field types
  const yesNoOptions = [
    { value: 'Yes', label: 'Yes' },
    { value: 'No', label: 'No' }
  ];

  // const driveModeOptions = [
  //   { value: 'Eco', label: 'Eco' },
  //   { value: 'Sport', label: 'Sport' },
  //   { value: 'Normal', label: 'Normal' }
  // ];

  const panelReplacementOptions = [
    { value: 'No', label: 'No' },
    { value: 'Left', label: 'Left' },
    { value: 'Right', label: 'Right' },
    { value: 'Both', label: 'Both' }
  ];

  const dentRepairReplaceOptions = [
    { value: 'Ok', label: 'Ok' },
    { value: 'Dent', label: 'Dent' },
    { value: 'Repair', label: 'Repair' },
    { value: 'Replace', label: 'Replace' }
  ];

  const damageLevelOptions = [
    { value: 'Normal', label: 'Normal' },
    { value: 'Minor', label: 'Minor' },
    { value: 'Major', label: 'Major' }
  ];

  const seatConditionOptions = [
    { value: 'Ok', label: 'Ok' },
    { value: 'Needs Repair', label: 'Needs Repair' },
    { value: 'Damaged', label: 'Damaged' }
  ];

  const interiorCleaningOptions = [
    { value: 'Ok', label: 'Ok' },
    { value: 'Vacuum', label: 'Vacuum' },
    { value: 'Shampoo', label: 'Shampoo' },
    { value: 'Heavy Cleaning', label: 'Heavy Cleaning' },
    { value: 'Odor', label: 'Odor' },
    { value: 'Carpet Damage', label: 'Carpet Damage' },
    { value: 'Bonnet Lining', label: 'Bonnet Lining' },
    { value: 'Backdoor Trim Damage', label: 'Backdoor Trim Damage' },
    { value: 'Roof Lamps', label: 'Roof Lamps' },
    { value: 'A/C Vents', label: 'A/C Vents' }
  ];

  // Render field with conditional cost and file - Optimized for compact layout
  const renderConditionalField = (fieldName, label, options, required = false, showFile = true, defaultValue = undefined) => {
    // Get initial value - only set if explicitly provided (not null or undefined)
    const initialValue = defaultValue !== null && defaultValue !== undefined ? defaultValue : undefined;

    return (
    <Col xl={8} lg={12} md={24} sm={24} xs={24} className='mb-2'>
      <div style={{ border: '1px solid #f0f0f0', borderRadius: '6px', padding: '12px', backgroundColor: '#fafafa' }}>
        <Form.Item
          label={<span style={{ fontSize: '12px', fontWeight: '500' }}>{label}</span>}
          name={fieldName}
          rules={required ? [{ required: true, message: `Please select ${label}` }] : []}
          {...(initialValue !== undefined ? { initialValue } : {})}
          style={{ marginBottom: '8px' }}
        >
          <Select className='form-control-ant' placeholder='Select Status' size='small'>
            {options.map(option => (
              <Select.Option key={option.value} value={option.value}>
                {option.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        {/* Conditional Cost and File Fields - Display below dropdown in same container */}
        <Form.Item dependencies={[fieldName]} noStyle>
          {({ getFieldValue }) => {
            const fieldValue = getFieldValue(fieldName);
            let shouldShow = false;

            // Special conditions for different fields
            if (fieldName === 'replaced_front_door_panel' || fieldName === 'replaced_rear_door_panel' || 
                fieldName === 'replaced_front_fender_panel' || fieldName === 'replaced_bonnet_hood_panel' || 
                fieldName === 'replaced_trunk_hood_panel') {
              shouldShow = fieldValue && fieldValue !== 'No';
            } else if (fieldName === 'driver_seat' || fieldName === 'co_driver_seat' || 
                       fieldName === 'rear_seats' || fieldName === 'sunroof' || 
                       fieldName === 'wireless_charger' || fieldName === 'cup_holders' || 
                       fieldName === 'glove_box' || fieldName === 'front_ac' || 
                       fieldName === 'rear_ac' || fieldName === 'front_floor_mat' || 
                       fieldName === 'rear_floor_mat' || fieldName === 'seat_belts_front' || 
                       fieldName === 'seat_belts_rear' || fieldName === 'door_handles_front' || 
                       fieldName === 'door_handles_rear' || fieldName === 'front_cross_member' ||
                       fieldName === 'upper_core_support' || fieldName === 'core_support' ||
                       fieldName === 'rear_wheel_house' || fieldName === 'front_side_member' ||
                       fieldName === 'front_inside_panel' || fieldName === 'front_pillar' ||
                       fieldName === 'center_pillar' || fieldName === 'roof_panel' ||
                       fieldName === 'dash_panel' || fieldName === 'floor_cross_member' ||
                       fieldName === 'floor_side_member' || fieldName === 'center_floor_panel' ||
                       fieldName === 'rear_side_member' || fieldName === 'rear_floor_panel' ||
                       fieldName === 'rear_inside_panel' || fieldName === 'rear_cross_member') {
              shouldShow = fieldValue && fieldValue !== 'Ok';
            } else {
              shouldShow = fieldValue === 'Yes';
            }

            return shouldShow ? (
              <Row gutter={[8, 0]}>
                <Col span={12}>
                  <Form.Item
                    label={<span style={{ fontSize: '11px' }}>Cost</span>}
                    name={`${fieldName}_cost`}
                    initialValue={0}
                    rules={[
                      {
                        required: true,
                        message: ``,
                      },
                      () => ({
                        validator(_, value) {
                          if (value === '' || value === null || value === undefined) {
                            return Promise.reject('Please enter a valid cost');
                          }
                          if (!/^\d{1,10}(\.\d{1,2})?$/.test(value)) {
                            return Promise.reject('Please enter a valid cost');
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                    style={{ marginBottom: '0' }}
                  >
                    <Input placeholder='Cost' className='form-control-ant' type='number' size='small' onKeyDown={(e) => { if (['e','E','+','-'].includes(e.key)) e.preventDefault(); }} />
                  </Form.Item>
                </Col>
                {showFile && (
                  <Col span={12}>
                    <Form.Item
                      label={<span style={{ fontSize: '11px' }}>File</span>}
                      name={`${fieldName}_file`}
                      rules={[
                        {
                          required: true,
                          message: `Please upload ${label} file`,
                          validator: () => {
                            if (fileList[`${fieldName}_file`] && fileList[`${fieldName}_file`].length > 0) {
                              return Promise.resolve();
                            }
                            return Promise.reject(new Error(`Please upload ${label} file`));
                          }
                        }
                      ]}
                      style={{ marginBottom: '0' }}
                    >
                      <UploadButton 
                        name={`${fieldName}_file`} 
                        fileList={fileList} 
                        setFileList={setFileList} 
                        fileType={['image/jpeg', 'image/png']} 
                        fileSizeLimit={5} 
                        documentType={`${fieldName}_file`} 
                        hideDeleteIcon={true}
                      />
                    </Form.Item>
                  </Col>
                )}
              </Row>
            ) : null;
          }}
        </Form.Item>
      </div>
    </Col>
    );
  };

  // Special renderer for cost-only fields
  const renderCostOnlyField = (fieldName, label, required = false) => (
    <Col xl={6} lg={8} md={12} sm={24} xs={24} className='mb-2'>
      <div style={{ border: '1px solid #f0f0f0', borderRadius: '6px', padding: '12px', backgroundColor: '#fafafa' }}>
        <Form.Item
          label={<span style={{ fontSize: '12px', fontWeight: '500' }}>{label}</span>}
          name={fieldName}
          initialValue={0}
          rules={[
            ...(required ? [{ required: true, message: `Please enter ${label}` }] : []),
            () => ({
                  validator(_, value) {
                    if (!value) {
                      return Promise.resolve();
                    }
                    if (!/^\d+(\.\d{1,2})?$/.test(value)) {
                      return Promise.reject(`Please enter a ${label}`);
                    }
                    const num = parseFloat(value);
                    if (num <= 0) {
                      return Promise.reject(`${label} must be greater than 0`);
                    }
                    if (num > 20000) {
                      return Promise.reject(`${label} cannot exceed 20000`);
                    }
                    return Promise.resolve();
                  },
                }),
          ]}
          style={{ marginBottom: '0' }}
        >
          <Input 
            placeholder='Enter Cost' 
            className='form-control-ant' 
            type='number' 
            size='small'
            min={0}
            max={200000}
            onKeyDown={(e) => { if (['e','E','+','-'].includes(e.key)) e.preventDefault(); }}
          />
        </Form.Item>
      </div>
    </Col>
  );

  // Special renderer for read-only cost fields
  const renderReadOnlyCostField = (fieldName, label) => (
    <Col xl={6} lg={8} md={12} sm={24} xs={24} className='mb-2'>
      <div style={{ border: '1px solid #f0f0f0', borderRadius: '6px', padding: '12px', backgroundColor: '#f5f5f5' }}>
        <Form.Item
          label={<span style={{ fontSize: '12px', fontWeight: '500' }}>{label}</span>}
          name={fieldName}
          style={{ marginBottom: '0' }}
        >
          <Input 
            placeholder='Auto Calculated' 
            className='form-control-ant' 
            type='number' 
            size='small'
            readOnly
            disabled
            style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
          />
        </Form.Item>
      </div>
    </Col>
  );

  // Special renderer for dropdown-only fields
  const renderDropdownOnlyField = (fieldName, label, options, required = false) => (
    <Col xl={6} lg={8} md={12} sm={24} xs={24} className='mb-2'>
      <div style={{ border: '1px solid #f0f0f0', borderRadius: '6px', padding: '12px', backgroundColor: '#fafafa' }}>
        <Form.Item
          label={<span style={{ fontSize: '12px', fontWeight: '500' }}>{label}</span>}
          name={fieldName}
          rules={required ? [{ required: true, message: `Please select ${label}` }] : []}
          style={{ marginBottom: '0' }}
        >
          <Select className='form-control-ant' placeholder='Select Status' size='small'>
            {options.map(option => (
              <Select.Option key={option.value} value={option.value}>
                {option.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </div>
    </Col>
  );

  // Special renderer for interior cleaning single select
  const renderInteriorCleaningField = (fieldName, label, required = false) => (
    <Col xl={8} lg={12} md={24} sm={24} xs={24} className='mb-2'>
      <div style={{ border: '1px solid #f0f0f0', borderRadius: '6px', padding: '12px', backgroundColor: '#fafafa' }}>
        <Form.Item
          label={<span style={{ fontSize: '12px', fontWeight: '500' }}>{label}</span>}
          name={fieldName}
          rules={required ? [{ required: true, message: `Please select ${label}` }] : []}
          style={{ marginBottom: '8px' }}
        >
          <Select className='form-control-ant' placeholder='Select Cleaning Type' size='small'>
            {interiorCleaningOptions.map(option => (
              <Select.Option key={option.value} value={option.value}>
                {option.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        {/* Conditional Cost and File Fields */}
        <Form.Item dependencies={[fieldName]} noStyle>
          {({ getFieldValue }) => {
            const fieldValue = getFieldValue(fieldName);
            const shouldShow = fieldValue && fieldValue !== 'Ok';

            return shouldShow ? (
              <Row gutter={[8, 0]}>
                <Col span={12}>
                  <Form.Item
                    label={<span style={{ fontSize: '11px' }}>Cost</span>}
                    name={`${fieldName}_cost`}
                    initialValue={0}
                    rules={[
                      {
                        required: true,
                        message: `Please input ${label.toLowerCase()} cost`,
                      },
                      () => ({
                        validator(_, value) {
                          if (value === '' || value === null || value === undefined) {
                            return Promise.reject('Please enter a valid cost');
                          }
                          if (!/^\d{1,10}(\.\d{1,2})?$/.test(value)) {
                            return Promise.reject('Please enter a valid cost');
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                    style={{ marginBottom: '0' }}
                  >
                    <Input placeholder='Cost' className='form-control-ant' type='number' size='small' onKeyDown={(e) => { if (['e','E','+','-'].includes(e.key)) e.preventDefault(); }} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label={<span style={{ fontSize: '11px' }}>File</span>}
                    name={`${fieldName}_file`}
                    rules={[
                      {
                        required: true,
                        message: `Please upload ${label.toLowerCase()} file`,
                        validator: () => {
                          // Check if file exists in fileList
                          if (fileList[`${fieldName}_file`] && fileList[`${fieldName}_file`].length > 0) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error(`Please upload ${label.toLowerCase()} file`));
                        }
                      }
                    ]}
                    style={{ marginBottom: '0' }}
                  >
                    <UploadButton 
                      name={`${fieldName}_file`} 
                      fileList={fileList} 
                      setFileList={setFileList} 
                      fileType={['image/jpeg', 'image/png']} 
                      fileSizeLimit={5} 
                      documentType={`${fieldName}_file`} 
                      hideDeleteIcon={true}
                    />
                  </Form.Item>
                </Col>
              </Row>
            ) : null;
          }}
        </Form.Item>
      </div>
    </Col>
  );

  return (
    <div>
      <Title level={4} className='mb-3'>Interior and Final Inspection</Title>
      
      {/* Vehicle Performance and Safety */}
      <Title level={5} className='mb-3'>Vehicle Performance and Safety</Title>
      <Row gutter={[16, 16]}>
        {renderConditionalField('abnormal_noise', 'Abnormal Noise', yesNoOptions, true, true, undefined)}
        {renderConditionalField('pedal_handling_defect', 'Pedal Handling Defect', yesNoOptions, true, false, undefined)}
        {renderConditionalField('alignment', 'Alignment', yesNoOptions, false, false, undefined)}
        {renderConditionalField('shock_absorber_defect', 'Shock Absorber Defect', yesNoOptions, true, true, undefined)}
        {renderConditionalField('seat_belt_lock', 'Seat Belt Lock', yesNoOptions, true, false, undefined)}
        {renderConditionalField('drive_mode_faulty', 'Drive Mode Faulty', yesNoOptions, true, true, undefined)}
        {renderConditionalField('lane_assist_defect', 'Lane Assist Defect', yesNoOptions, true, true, undefined)}
        {renderConditionalField('hill_assist_defect', 'Hill Assist Defect', yesNoOptions, false, true, undefined)}
      </Row>
      
      <div className='h-line'>&nbsp;</div>

      {/* Body Panel Replacements */}
      <Title level={5} className='mb-3'>Body Panel Replacements</Title>
      <Row gutter={[16, 16]}>
        {renderConditionalField('replaced_front_door_panel', 'Replaced Front Door Panel', panelReplacementOptions, true, true, undefined)}
        {renderConditionalField('replaced_rear_door_panel', 'Replaced Rear Door Panel', panelReplacementOptions, true, true, undefined)}
        {renderConditionalField('replaced_front_fender_panel', 'Replaced Front Fender Panel', panelReplacementOptions, true, true, undefined)}
        {renderConditionalField('replaced_bonnet_hood_panel', 'Replaced Bonnet Hood Panel', panelReplacementOptions, true, true, undefined)}
        {renderConditionalField('replaced_trunk_hood_panel', 'Replaced Trunk Hood Panel', panelReplacementOptions, true, true, undefined)}
      </Row>
      
      <div className='h-line'>&nbsp;</div>

      {/* Structural Components */}
      <Title level={5} className='mb-3'>Structural Components</Title>
      <Row gutter={[16, 16]}>
        {renderConditionalField('front_cross_member', 'Front Cross Member', dentRepairReplaceOptions, true, true, undefined)}
        {renderConditionalField('upper_core_support', 'Upper Core Support', dentRepairReplaceOptions, true, true, undefined)}
        {renderConditionalField('core_support', 'Core Support', dentRepairReplaceOptions, false, true, 'Ok')}
        {renderConditionalField('rear_wheel_house', 'Rear Wheel House', dentRepairReplaceOptions, false, true, 'Ok')}
        {renderConditionalField('front_side_member', 'Front Side Member', dentRepairReplaceOptions, false, true, 'Ok')}
        {renderConditionalField('front_inside_panel', 'Front Inside Panel', dentRepairReplaceOptions, false, true, 'Ok')}
        {renderConditionalField('front_pillar', 'Front Pillar', dentRepairReplaceOptions, true, true, undefined)}
        {renderConditionalField('center_pillar', 'Center Pillar', dentRepairReplaceOptions, true, true, undefined)}
        {renderConditionalField('roof_panel', 'Roof Panel', dentRepairReplaceOptions, true, true, undefined)}
        {renderConditionalField('dash_panel', 'Dash Panel', dentRepairReplaceOptions, true, true, 'Ok')}
        {renderConditionalField('floor_cross_member', 'Floor Cross Member', dentRepairReplaceOptions, true, true, 'Ok')}
        {renderConditionalField('floor_side_member', 'Floor Side Member', dentRepairReplaceOptions, true, true, 'Ok')}
        {renderConditionalField('center_floor_panel', 'Center Floor Panel', dentRepairReplaceOptions, true, true, 'Ok')}
        {renderConditionalField('rear_side_member', 'Rear Side Member', dentRepairReplaceOptions, true, true, 'Ok')}
        {renderConditionalField('rear_floor_panel', 'Rear Floor Panel', dentRepairReplaceOptions, true, true, 'Ok')}
        {renderConditionalField('rear_inside_panel', 'Rear Inside Panel', dentRepairReplaceOptions, true, true, 'Ok')}
        {renderConditionalField('rear_cross_member', 'Rear Cross Member', dentRepairReplaceOptions, true, true, 'Ok')}
      </Row>
      
      <div className='h-line'>&nbsp;</div>

      {/* Body Damage Assessment */}
      <Title level={5} className='mb-3'>Body Damage Assessment</Title>
      <Row gutter={[16, 16]}>
        {renderDropdownOnlyField('front_body_damage', 'Front Body Damage', damageLevelOptions, true)}
        {renderDropdownOnlyField('right_body_damage', 'Right Body Damage', damageLevelOptions, true)}
        {renderDropdownOnlyField('left_body_damage', 'Left Body Damage', damageLevelOptions, true)}
        {renderDropdownOnlyField('rear_body_damage', 'Rear Body Damage', damageLevelOptions, true)}
        {renderDropdownOnlyField('underbody_damage', 'Underbody Damage', damageLevelOptions, true)}
        {renderDropdownOnlyField('rust_body_damage', 'Rust Body Damage', damageLevelOptions, true)}
      </Row>
      
      <div className='h-line'>&nbsp;</div>

      {/* Refurbishment Costs */}
      <Title level={5} className='mb-3'>Refurbishment Costs</Title>
      <Row gutter={[16, 16]}>
        {renderCostOnlyField('front_refurbishment_cost', 'Front Refurbishment Cost', true)}
        {renderCostOnlyField('right_refurbishment_cost', 'Right Refurbishment Cost', true)}
        {renderCostOnlyField('left_refurbishment_cost', 'Left Refurbishment Cost', true)}
        {renderCostOnlyField('rear_refurishment_cost', 'Rear Refurbishment Cost', true)}
        {renderCostOnlyField('underbody_refurishment_cost', 'Underbody Refurbishment Cost', true)}
        {renderCostOnlyField('rust_refurishment_cost', 'Rust Refurbishment Cost', true)}
        {renderCostOnlyField('other_refurishment_cost', 'Other Refurbishment Cost', true)}
        {renderReadOnlyCostField('total_refurishment_cost', 'Total Refurbishment Cost')}
      </Row>
      
      <div className='h-line'>&nbsp;</div>

      {/* Seating */}
      <Title level={5} className='mb-3'>Seating</Title>
      <Row gutter={[16, 16]}>
       
        {renderConditionalField('driver_seat', 'Driver Seat', seatConditionOptions, true, true, 'Ok')}
        {renderConditionalField('co_driver_seat', 'Co Driver Seat', seatConditionOptions, true, true, 'Ok')}
        {renderConditionalField('rear_seats', 'Rear Seat', seatConditionOptions, true, true, 'Ok')}
      </Row>
      
      <div className='h-line'>&nbsp;</div>

      {/* Interior Features */}
      <Title level={5} className='mb-3'>Interior Features</Title>
      <Row gutter={[16, 16]}>
        {renderConditionalField('sunroof', 'Sunroof', seatConditionOptions, true, true, undefined)}
        {renderConditionalField('wireless_charger', 'Wireless Charger', seatConditionOptions, true, true, 'Ok')}
        {renderConditionalField('cup_holders', 'Cup Holders', seatConditionOptions, true, true, 'Ok')}
        {renderConditionalField('glove_box', 'Glove Box', seatConditionOptions, true, true, 'Ok')}
        {renderConditionalField('front_ac', 'Front AC', seatConditionOptions, true, true, undefined)}
        {renderConditionalField('rear_ac', 'Rear AC', seatConditionOptions, true, true, 'Ok')}
        {renderConditionalField('front_floor_mat', 'Front Floor Mat', seatConditionOptions, true, true, 'Ok')}
        {renderConditionalField('rear_floor_mat', 'Rear Floor Mat', seatConditionOptions, true, true, 'Ok')}
        {renderConditionalField('seat_belts_front', 'Seat Belt Front', seatConditionOptions, true, true, 'Ok')}
        {renderConditionalField('seat_belts_rear', 'Seat Belt Rear', seatConditionOptions, true, true, 'Ok')}
        {renderConditionalField('door_handles_front', 'Door Handles Front', seatConditionOptions, true, true, 'Ok')}
        {renderConditionalField('door_handles_rear', 'Door Handles Rear', seatConditionOptions, true, true, 'Ok')}
      </Row>
      
      <div className='h-line'>&nbsp;</div>

      {/* Interior Cleaning */}
      <Title level={5} className='mb-3'>Interior Cleaning</Title>
      <Row gutter={[16, 16]}>
        {renderInteriorCleaningField('interior_cleaning', 'Interior Cleaning', true)}
      </Row>
    </div>
  );
};

export default Step4InteriorFinalInspectionForm;

